// Data for mamy!kongres — placeholders that can be edited later.

export const EVENT = {
  name: "mamy!kongres",
  date: "22.05.2027",
  dateLong: "22 maja 2027",
  city: "Warszawa",
  venue: "Akademia Sztuk Pięknych, Wybrzeże Kościuszkowskie 37/39",
  hours: "9:00 – 18:30",
};

export const NAV_LINKS = [
  { to: "/", label: "Start", testid: "nav-home" },
  { to: "/o-kongresie", label: "O kongresie", testid: "nav-about" },
  { to: "/prelegentki", label: "Prelegentki", testid: "nav-speakers" },
  { to: "/agenda", label: "Agenda", testid: "nav-agenda" },
  { to: "/sponsorzy", label: "Sponsorzy i partnerzy", testid: "nav-sponsors" },
  { to: "/wspolpraca", label: "Zostań sponsorem", testid: "nav-cooperation" },
  { to: "/kontakt", label: "Kontakt", testid: "nav-contact" },
  { to: "/poznajmy-sie", label: "Poznajmy się", testid: "nav-poznajmy" },
  { to: "/regulamin", label: "Regulamin", testid: "nav-regulamin" },
];

export const SPEAKERS = [
  {
    id: 1,
    name: "Anna Kowalska",
    title: "Psycholożka macierzyństwa",
    bio: "Autorka bestsellera „Spokojna Mama”. Prowadzi warsztaty dla świeżo upieczonych mam w całej Polsce.",
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 2,
    name: "Magdalena Nowak",
    title: "Ekspertka od work-life balance",
    bio: "Coach kariery. Pokazuje, jak łączyć macierzyństwo z rozwojem zawodowym bez wypalenia.",
    photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 3,
    name: "dr Zuzanna Wiśniewska",
    title: "Pediatra, autorka podcastu",
    bio: "Głos rozsądku w internecie o zdrowiu dziecka. Podcast „Bez paniki, mamo!” — pół miliona odsłuchań.",
    photo: "https://images.unsplash.com/photo-1573496130141-209d200cebd8?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 4,
    name: "Karolina Zielińska",
    title: "Dietetyczka rodzinna",
    bio: "Twórczyni bloga „Mama gotuje inaczej”. Uczy jak karmić rodzinę bez wieczornych awantur nad talerzem.",
    photo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 5,
    name: "Ewa Lewandowska",
    title: "Doula, edukatorka porodowa",
    bio: "Przez 15 lat wsparła ponad 800 kobiet w porodzie. Prowadzi szkołę rodzenia „Świadomie”.",
    photo: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 6,
    name: "Aleksandra Mazur",
    title: "Founderka, przedsiębiorczyni",
    bio: "Zbudowała firmę wartą 30 mln na urlopie macierzyńskim. Mentor programu „Mama zakłada biznes”.",
    photo: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 7,
    name: "Julia Wójcik",
    title: "Fizjoterapeutka uroginekologiczna",
    bio: "Specjalizuje się w powrocie do formy po porodzie. Autorka programu „Odzyskaj swoje ciało”.",
    photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=800&q=80&sat=-100",
  },
  {
    id: 8,
    name: "Natalia Kamińska",
    title: "Aktywistka, twórczyni internetowa",
    bio: "Głos społeczności „Głośne Mamy” — 350 tys. obserwujących. Rozmawia o tym, o czym się nie mówi.",
    photo: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=800&q=80",
  },
];

export const AGENDA = [
  { time: "09:00 – 09:45", title: "Rejestracja", speaker: "", type: "break" },
  { time: "09:45 – 10:00", title: "Powitanie", speaker: "", type: "keynote" },
  { time: "10:00 – 11:00", title: "TED-y prelegentek", speaker: "", type: "keynote" },
  { time: "11:00 – 11:30", title: "Panel dyskusyjny", speaker: "", type: "talk" },
  { time: "11:45 – 12:30", title: "Warsztaty — część 1", speaker: "", type: "talk", sub: "przerwa na kawę, rozmowy networkingowe, stoliki tematyczne." },
  { time: "12:45 – 13:30", title: "Warsztaty — część 2", speaker: "", type: "talk", sub: "przerwa na kawę, rozmowy networkingowe, stoliki tematyczne." },
  { time: "13:30 – 14:30", title: "Przerwa obiadowa", speaker: "", type: "break" },
  { time: "14:30 – 15:30", title: "TED-y prelegentek", speaker: "", type: "keynote" },
  { time: "15:40 – 16:25", title: "Warsztaty — część 3", speaker: "", type: "talk", sub: "przerwa na kawę, rozmowy networkingowe, stoliki tematyczne." },
  { time: "16:30 – 17:15", title: "Warsztaty — część 4", speaker: "", type: "talk", sub: "przerwa na kawę, rozmowy networkingowe, stoliki tematyczne." },
  { time: "17:20 – 18:00", title: "Panel dyskusyjny", speaker: "", type: "talk" },
  { time: "18:00 – 18:15", title: "mamy!DANCE", speaker: "", type: "keynote" },
  { time: "18:15 – 18:45", title: "Zakończenie i podziękowania", speaker: "", type: "keynote" },
];

export const FAQ = [
  {
    q: "Kto może wziąć udział w kongresie?",
    a: "Kongres jest przeznaczony dla mam na każdym etapie macierzyństwa — od tych, które planują dziecko, przez świeżo upieczone, po mamy nastolatków.",
  },
  {
    q: "Czy w cenie jest catering?",
    a: "Tak. W cenie biletu znajdują się przerwy kawowe oraz lunch.",
  },
  {
    q: "Jak wygląda proces zapisu?",
    a: "Wypełnij formularz w zakładce „Zapisz się”. W ciągu 24h otrzymasz e-mail z potwierdzeniem oraz danymi do płatności. Bilet zostanie wysłany po zaksięgowaniu wpłaty.",
  },
  {
    q: "Czy jest możliwość zwrotu?",
    a: "Bilet na Mamy Kongres jest biletem na wydarzenie odbywające się w oznaczonym dniu – 22 maja 2027 r. Zgodnie z art. 38 pkt 12 ustawy o prawach konsumenta zakup biletu nie podlega 14-dniowemu prawu odstąpienia od umowy. W przypadku rezygnacji z udziału możesz bezpłatnie przekazać bilet innej osobie, na zasadach określonych w Regulaminie.",
  },
];

export const STATS = [
  { value: "300+", label: "uczestniczek" },
  { value: "10", label: "prelegentek" },
  { value: "9h", label: "inspiracji" },
  { value: "1", label: "niesamowity dzień" },
];
